import { z } from "zod";

// Basic email format validation
export function validateEmailFormat(email: string): boolean {
	return z.string().email().safeParse(email).success;
}

// Zod schema for required email - Zod v4 syntax
export const emailSchema = z
	.string()
	.email("Please enter a valid email address");

// Zod schema for optional email (allows empty)
export const optionalEmailSchema = z
	.string()
	.optional()
	.refine(
		(email) => {
			if (!email || email === "") return true; // Allow empty
			return validateEmailFormat(email);
		},
		{
			message: "Please enter a valid email address",
		},
	);

// For backwards compatibility with existing validateEmail import
export function validateEmail(email: string): boolean {
	return validateEmailFormat(email);
}
